/** An agent's page, where its instructions and settings are edited. */
export function messagingAgentHref(agentId: string): string {
  return `?page=messaging-agents&agentId=${encodeURIComponent(agentId)}`
}
